import React, { FunctionComponent, ReactElement, ReactNode } from 'react';

import { css } from '@emotion/react';
import VerifiedIcon from '@mui/icons-material/Verified';

import { palette } from '@styles/theme';

interface Props {
  label: string | ReactNode | ReactElement;
  width?: string;
  required?: boolean;
  children?: ReactNode | ReactElement;
}

const FormSection: FunctionComponent<Props> = ({
  label,
  width = '140px',
  required,
  children,
}) => {
  return (
    <li css={container}>
      <div css={flexRow(width)}>
        <div css={labelStyle}>
          {label}
          {required && (
            <span css={requiredStyle}>
              <VerifiedIcon />
            </span>
          )}
        </div>
        <div css={bodys}>{children}</div>
      </div>
    </li>
  );
};

export default FormSection;

const container = css`
  // height: 100%;
  float: left;
  padding: 0;
  margin: 0;
`;

const flexRow = (width: string) => css`
  display: grid;
  grid-template-columns: ${width} auto 0;
  height: 100%;
  // overflow: hidden;
  padding: 0;
  margin: 0;
  & > * {
    line-height: 16px;
  }
`;

const labelStyle = css`
  background-color: ${palette.gray2};
  width: 100%;
  padding: 17px;
  font-size: 14px;
  font-weight: 700;
  word-break: keep-all;
  position: relative;
`;

const requiredStyle = css`
  position: absolute;
  top: 17px;
  margin-left: 3px;
  svg {
    fill: ${palette.colorGreen500};
    width: 13px;
    height: 13px;
  }
`;

const bodys = css`
  background-color: white;
  padding-left: 17px;
  font-size: 14px;
  font-weight: 400;
  // overflow: auto;
  display: flex;
  align-items: center;
  // position: relative;
`;
